<template>
  <div :class="$style['pt-assigned-tasks-form']">
    <pt-page-title :title="hasBatch?'批量分配任务':'单个分配任务'"></pt-page-title>
    <pt-sub-title title="分配任务"></pt-sub-title>
    <table>
      <pt-form-list-item label="选择报名记录：" required>
        <div>
          <el-button :disabled="!hasBatch" @click="chooseRegistrationRecord" plain type="primary">点击选择</el-button>
          <wt-input style="display:none" data-vv-as="报名记录" v-validate="'required'" v-model="formValue.recordDataLength"></wt-input>
          <div :class="$style['specification-table-div']" class="page-background" v-if="formValue.recordData.length">
            <table :class="$style['specification-table']">
                <th>
                    <td>姓名</td>
                    <td>手机号</td>
                    <td>性别</td>
                    <td>报告名称</td>
                    <td>样本条码号</td>
                    <td>报名时间</td>
                    <td>地区</td>
                    <td>预约状态</td>
                    <td>复购意向</td>
                    <td v-if="hasBatch">操作</td>
                </th>
                <tr v-for="(item,index) in formValue.recordData" :key="item.id">
                    <td>{{item.genericFormData.data.name}}</td>
                    <td>{{item.genericFormData.data.phone}}</td>
                    <td>{{item.gender}}</td>
                    <td>{{item.genericFormData.data.reportName}}</td>
                    <td>{{item.genericFormData.data.sampleId}}</td>
                    <td>{{item.registration_time}}</td>
                    <td>{{item.area}}</td>
                    <td>{{item.sign_status}}</td>
                    <td>{{item.repurchase_intention}}</td>
                    <td v-if="hasBatch"><el-button @click="removeRecord(index)" type="text">移除</el-button></td>
                </tr>
            </table>
          </div>
        </div>
      </pt-form-list-item>
      <pt-form-list-item label="选择解读人员：" required>
        <div>
          <el-button type="primary" @click="chooseReadPeople" plain>点击选择</el-button>
          <wt-input style="display:none" data-vv-as="解读人员" v-validate="'required'" v-model="formValue.unscramblePerson.userId"></wt-input>
          <div :class="$style['specification-table-div']" class="page-background" v-if="formValue.unscramblePerson.userId">
            <table :class="$style['specification-table']">
                <th>
                    <td>姓名</td>
                    <td>当前的解读次数</td>
                    <td>一周内的最大解读次数</td>
                    <td>微信号</td>
                </th>
                <tr>
                    <td>{{formValue.unscramblePerson.name}}</td>
                    <td>{{formValue.unscramblePerson.currentUnscrambleTime}}</td>
                    <td>{{formValue.unscramblePerson.unscrambleTimePerWeek}}</td>
                    <td>{{formValue.unscramblePerson.wechatId}}</td>
                </tr>
            </table>
          </div>
        </div>
      </pt-form-list-item>
    </table>
    <el-dialog width="70%" title="选择报名记录" :visible.sync="registrationRecordVisible" v-if="registrationRecordVisible">
      <pt-page-factor-filter  :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter>
      <pt-notes-table @chooseRecord="chooseRecord" ref="table" :isSelect="true" :id="id" :params-data="paramsData" :isFromRouter="false" :isParse="true" :isQuestion="false"
     :isLifeExperienceHall="false">
      </pt-notes-table>
      <div>
        <el-button @click="confirmRecord" type="primary">确定</el-button>
        <el-button @click="cancelRecord" type="primary" plain>取消</el-button>
      </div>
    </el-dialog>
    <el-dialog width="70%" title="选择解读人员" :visible.sync="readPeoplelVisible" v-if="readPeoplelVisible">
      <pt-read-people-table :paramsData="readPeoplelParamsData" :isAddPageToRouter="false" :tableLabels="tableLabels">
        <template slot="before">
          <el-table-column label="" width="35">
            <template slot-scope="scope">
              <el-radio v-model="currentData" :label="scope.row"></el-radio>
            </template>
          </el-table-column>
        </template>
      </pt-read-people-table>
      <div class="button-div">
        <el-button @click="confirmReadPeople" type="primary">确定</el-button>
        <el-button @click="cancelReadPeople" type="primary" plain>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import ptNotesTable from '../pt-notes-table/withData'
import ptReadPeopleTable from '../pt-read-people/withData'
import { allotUnscrambleUserLabels, readPeopleTableLabels } from '../active-sign-notes'
import { emptyObject } from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-assigned-tasks-form'

export default {
  name: 'pt-assigned-tasks-form',
  mixins: [formMixins],
  components: { ptNotesTable, ptReadPeopleTable },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    hasBatch () {
      return this.recordId === '0'
    }
  },
  watch: {
    notesDetail: {
      handler: function (val) {
        if (Object.keys(val).length) {
          this.formValue.recordData.push(val)
          this.formValue.recordDataLength = this.formValue.recordData.length
        }
      },
      deep: true
    },
    userDetail: {
      handler: function (val) {
        if (val.userId) {
          this.formValue.unscramblePerson = val
        }
      },
      deep: true
    }
  },
  props: {
    notesDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      formValue: {
        recordData: [],
        unscramblePerson: {}
      },
      paramsData: { workflowStatusList: ['CONFIRMED', 'UNCONFIRMED'] },
      readPeoplelParamsData: { role: 'ROLE_REPORT_EXPLAIN_MANAGE' },
      params: {},
      filterLabels: allotUnscrambleUserLabels,
      registrationRecordVisible: false,
      id: this.$route.params.id,
      recordId: this.$route.params.recordId,
      recordData: [],
      readPeoplelVisible: false,
      tableLabels: readPeopleTableLabels,
      currentData: {}
    }
  },
  methods: {
    // 选择报名记录
    chooseRegistrationRecord () {
      this.registrationRecordVisible = true
    },
    chooseRecord (val) {
      this.recordData = val
    },
    confirmRecord () {
      this.formValue.recordData = this.recordData
      this.formValue.recordDataLength = this.recordData.length
      this.registrationRecordVisible = false
    },
    cancelRecord () {
      this.registrationRecordVisible = false
    },
    removeRecord (val) {
      this.formValue.recordData.splice(val, 1)
    },
    // 选择解读人员
    chooseReadPeople () {
      this.readPeoplelVisible = true
    },
    confirmReadPeople () {
      this.formValue.unscramblePerson = this.currentData
      this.readPeoplelVisible = false
    },
    cancelReadPeople () {
      this.readPeoplelVisible = false
    },
    Filter () {
      let data = JSON.parse(JSON.stringify(this.params))
      this.paramsData = { ...this.paramsData, ...data }
    },
    cleanParams () {
      emptyObject(this.params)
      this.paramsData = { workflowStatusList: ['CONFIRMED', 'UNCONFIRMED'] }
      this.Filter()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-assigned-tasks-form{
  table{
    padding: 0 20px;
  }
.specification-table-div{
    margin: 20px 0;
    padding: 10px 20px 30px;
  }
.specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row!important;
        padding: 0!important;
        list-style-type:none;
        justify-content:center!important;
        border-bottom: 1px solid #C6C9D3;
        color: #5B5B5B!important;
    }
    td{
        color: #5B5B5B!important;
        text-align: center;
        justify-content:flex-start!important;
        padding: 10px;
    }
  }
}

</style>
